<template>
  <div class="text-center">
    <v-dialog v-model="dialogPrizes" width="500" transition="slide-y-transition">
      <v-card>
        <v-card-title class="headline white--text primary gradient-mariana py-3 mb-4" primary-title>
          <v-avatar size="36" tile>
            <v-img src="/img/prize.svg"></v-img>
          </v-avatar>
          <span style="margin-bottom:-5px" class="ml-4">Prizes</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            icon
            dark
            @click="dialogPrizes = false"
            style="margin-right:-10px"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mb-0 pb-2">
          <div class="Legend">
            <div class="Legend-item">
              <div class="Legend-itemTitle">2 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[0].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[0].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[0].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">4 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[1].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[1].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[1].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">
                1
                <v-avatar size="20" tile>
                  <v-img :src="customer.slotMachineRewardUrl"></v-img>
                </v-avatar>
              </div>
              <img class="Legend-itemImage" :src="reelSourceData[2].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[2].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[2].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">16 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[3].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[3].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[3].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">3 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">18 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
            </div>
            <div class="Legend-item">
              <div class="Legend-itemTitle">72 ⭐</div>
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
              <img class="Legend-itemImage" :src="reelSourceData[4].slotMachineRewardUrl" />
            </div>
          </div>
          <div class="Legend-tip mb-3">Tip: click on reel to lock it.</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState(["reelSourceData", "customer"]),
    dialogPrizes: {
      get() {
        return this.$store.state.dialogPrizes;
      },
      set(val) {
        return this.$store.commit("setDialogPrizes", val);
      }
    }
  }
};
</script>

<style>
.Legend {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}
.Legend-item {
  width: 100%;
  display: flex;
}

.Legend-itemTitle {
  text-align: end;
  padding-top: 5px;
  padding-right: 12px;
  width: 52px;
  color: #413f41;
  margin-right: 10px;
}

.Legend-itemImage {
  max-width: 30px;
  max-height: 30px;
}

.Legend-tip {
  margin-top: 8px;
  font-size: 10px;
  color: #413f41;
}

.Legend-credit {
  margin-top: 8px;
  font-size: 10px;
  font-style: italic;
  color: #413f41;
}
</style>